import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getLocales } from '../redux/actions/app';
import { login } from '../redux/actions/auth';
import TextField from '../components/TextField';
import CustomButton from '../components/CustomButton';
import LanguageSelector from '../components/LanguageSelector';
import logo from '../assets/logo.png';
import { useNavigate } from 'react-router-dom';
import '../style/screens/login.css';
import { hasCapability } from '../utils/capabilities';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.state.token);
  const user = useSelector((state) => state.auth?.user);
  const logerror = useSelector((state) => state.auth.logerror);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Helper function to determine first available route based on capabilities
  const getDefaultRoute = useCallback(() => {
    if (!user?.role) return '/home';

    const { role, adminCapabilities = [] } = user;

    // Legacy role redirects
    if (role === 'photographer_editor') return '/tools';
    if (role === 'knowledge_editor') return '/knowledge';
    if (role === 'calendar_editor') return '/home';

    // Admin with capabilities
    if (role === 'admin') {
      // Prioritize routes based on capabilities
      if (hasCapability(adminCapabilities, 'content')) return '/home';
      if (hasCapability(adminCapabilities, 'analytics')) return '/useranalytics';
      if (hasCapability(adminCapabilities, 'translation')) return '/translations';

      // If admin has no capabilities, redirect to help
      return '/help';
    }

    return '/home';
  }, [user]);

  useEffect(() => {
    if (token !== '') {
      // Only navigate if user data is loaded
      if (user && user.role) {
        navigate(getDefaultRoute());
      }
    } else {
      dispatch(getLocales());
    }
  }, [navigate, token, dispatch, user, getDefaultRoute]);

  return (
    <div className="bg-orange flex items-center justify-center pt-16 h-screen">
      <div className="login-container">
        <div className="flex flex-col justify-center items-center mb-4">
          <img alt="logo" src={logo} />
          <LanguageSelector style={{ marginTop: '10px' }} />
        </div>
        <div className="bg-white rounded p-8 pt-12 shadow">
          <TextField
            type="text"
            label="E-mail:"
            name="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <TextField
            type="password"
            label="Password:"
            name="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          <CustomButton onClick={() => dispatch(login(email, password))}>Log in</CustomButton>
          <p stlye={{ color: 'red' }}>{logerror}</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
